/* import __COLOCATED_TEMPLATE__ from './add-card-flow.hbs'; */
import { action } from '@ember/object';
import { convertToCents } from 'client-portal/helpers/format-money';
import { error as errorBanner } from 'ember-simplepractice/utils/banners';
import { registerDestructor } from '@ember/destroyable';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Component from '@glimmer/component';

export default class SiteBillingPaymentInstrumentPaymentModalCheckoutAddCardFlow extends Component {
  @service billingModals;
  @service paymentInstrumentModals;
  @service currentPractice;
  @service intl;
  @service localeManager;
  @service store;
  @service stripe;
  @service stripePaymentModeElementService;

  @tracked stripeElement;

  constructor() {
    super(...arguments);

    this.attachDraftCardToPayment();
    this.setupStripePaymentModeElement();
    registerDestructor(this, () => this.teardownStripePaymentModeElement());
  }

  attachDraftCardToPayment() {
    const card = this.store.createRecord('card', {
      name: this.billingModals.session.currentClientAccess.client.preferredName,
      _saveCard: true,
      isDefault: true,
    });

    this.paymentInstrumentModals.setPaymentInstrument(this.args.model, card);
  }

  @action
  exitAddingCard() {
    this.discardDraftCard();
    this.restoreDefaultSavedCard();

    this.args.onExit();
  }

  discardDraftCard() {
    const instrument = this.args.model.stripePaymentInstrument;

    if (instrument?.isNew) {
      instrument.deleteRecord();
    }
  }

  restoreDefaultSavedCard() {
    const card = this.paymentInstrumentModals.defaultSavedCard;

    this.paymentInstrumentModals.setPaymentInstrument(this.args.model, card ?? null);
  }

  @action
  syncStripeAmount() {
    if (this.billingModals.isPaymentInvalid || !this.stripeElement) {
      return;
    }

    this.stripePaymentModeElementService.update({
      amount: convertToCents(this.args.model.amount),
    });
  }

  setupStripePaymentModeElement() {
    try {
      this.stripeElement = this.stripePaymentModeElementService.createElement(
        this.stripe.stripe,
        this.paymentOptions()
      );
      this.args.onStripeElementChange?.(this.stripeElement);
    } catch (_err) {
      errorBanner({
        title: this.intl.t('billing.states.unableToLoad'),
        isTransient: true,
      });
    }
  }

  teardownStripePaymentModeElement() {
    this.args.onStripeElementChange?.(null);
    this.stripePaymentModeElementService.destroyElement();
    this.stripeElement = null;
  }

  paymentOptions() {
    return {
      amount: this.args.model.amount,
      currency: this.currentPractice.get('currency'),
      onBehalfOf: this.currentPractice.get('stripeConnectedAccountId'),
      paymentMethodTypes: ['card'],
      locale: this.localeManager.currentLocaleForStripe,
      featureStripeLinkPassthroughMode: this.currentPractice.get(
        'featureStripeLinkPassthroughMode'
      ),
    };
  }
}
